var _path, _path2, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAdminShield = function SvgAdminShield(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1,
    d: "M2.5,2.5 C2.5,1.99796859 2.90245128,1.5999999 3.5,1.5 C3.5,1.5 6,1.16666667 11,0.5 C16,1.16666667 18.5,1.5 18.5,1.5 C19.1032699,1.5999999 19.5,2.00438553 19.5,2.5 C19.5,2.5 19.5,4.83333333 19.5,9.5 C19.5,17.9500008 12,21.5 11,21.5 C10,21.5 2.5,17.9500008 2.5,9.5 C2.5,4.83333333 2.5,2.5 2.5,2.5 Z M18.5,9.5 L18.5,2.5 L11.0016142,1.5 L3.5,2.5 L3.5,9.5 C3.5,16.9500008 10,20.5 11,20.5 C12,20.5 18.5,16.9500008 18.5,9.5 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 4,
    d: "M16.9987179,12 C16.9987179,15 13.9338052,18 13,18 L13,12 L16.9987179,12 Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    stroke: "currentColor",
    strokeWidth: 4,
    points: "9 3 9 8 5 8 5 3.81845202"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAdminShield);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/admin-shield.55ea08f42a904a4d5c1e0da2c3db5eba.svg";